import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from '../api-routes';
import {
  type RecentContact,
  getRecentContactFn,
} from './get-recent-contact-fn';

export const useGetRecentContact = (
  opts?: UseQueryOptions<RecentContact[], DefaultQueryError>
) =>
  useQuery<RecentContact[], DefaultQueryError>({
    queryKey: [apiRoutes.order.recentContact],
    queryFn: () => getRecentContactFn(),
    ...opts,
  });
